import { Component, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import * as moment from 'moment';
import { ApprobationService } from '../services/approbation.service';
import { NotifierService } from '../shared/notifier/notifier.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { AlertComponent } from '../../shared';
import { IWorkOrder } from '../work-order/new-work-order/new-work-order.component';
import * as fileSaver from 'file-saver';
import { ReportesService } from '../services/reportes.service';


@Component({
  selector: 'app-approbation-group',
  templateUrl: 'approbation-group.component.html',
  styleUrls: ['./approbation-group.scss'],
  providers: [ApprobationService, ReportesService]
})
export class ApprobationGroupComponent implements OnInit {

  tableSettingsBudgetHeader: any = undefined;
  dataSourceBudgetHeader: any = undefined;
  tableDataBudgetHeader: any = {};
  ldvStates: any = {};
  perPage = 10;
  settings = {
    pager: { display: true, perPage: this.perPage },
    noDataMessage: 'No hay datos que mostrar.', columns: undefined,
    actions: {
      add: false, delete: false, position: 'right', edit: false, columnTitle: 'Acciones',
      custom: [
        { name: 'editar', title: `<div class="editCustomButton">Editar</div>` },
        { name: 'eliminar', title: `<div class="editCustomButton">Eliminar</div>` }
      ]
    }
  };

  constructor(private reporteService: ReportesService,
    private approbationService: ApprobationService,
    private notifierService: NotifierService,
    private routes: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog) {

    this.tableDataBudgetHeader = {
      columns: {
        nombreGrupo: { title: 'Nombre de grupo' },
        nombreTipo: { title: 'Tipo de aprobación' },
        orden: { title: 'Orden de aprobación' },
      },
      data: {}
    };
  }

  ngOnInit() {
    this.approbationService.getAprobbations().subscribe((result) => {
      this.getTableData(result);
    }, (error) => {
      this.getTableData([]);
    });
  }


  exportExcel() {
    let headerData;
    let copyData;

    headerData = [
      { dataBound: 'nombreGrupo', name: 'Nombre de grupo', width: 40 },
      { dataBound: 'nombreTipo', name: 'Tipo de aprobación', width: 30 },
      { dataBound: 'orden', name: 'Orden de aprobación', width: 30 }];
    const data = this.dataSourceBudgetHeader.filteredAndSorted;
    copyData = this.dataSourceBudgetHeader.filteredAndSorted;
    const nameProyect = 'Reporte hora por cliente';



    const options = {
      fieldSeparator: ';',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      useBom: true,
      headers: ['Nombre de grupo', 'Tipo de aprobación', 'Orden de aprobación']
    };
    this.reporteService.exportExcel(headerData, copyData).subscribe(result => {
      const mediaType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const blob = new Blob([result._body], { type: mediaType });
      const fileName = 'Reporte';
      fileSaver.saveAs(blob, fileName);
    });

  }





  copyObject(obj): object {
    return JSON.parse(JSON.stringify(obj));
  }

  getTableData(result) {
    const cloneRows: Array<any> = [...result];

    this.dataSourceBudgetHeader = new LocalDataSource(cloneRows);
    this.tableSettingsBudgetHeader = this.copyObject(this.settings);
    if (this.tableDataBudgetHeader.columns !== undefined) {
      this.tableSettingsBudgetHeader.columns = this.copyObject(this.tableDataBudgetHeader.columns);
      // Se deshabilita los filtros predefinidos para evitar conflictos
      Object.keys(this.tableSettingsBudgetHeader.columns).forEach(key => {
        this.tableSettingsBudgetHeader.columns[key].filter = true;
      });
    }
  }
  customAction(event) {
    switch (event.action) {
      case 'editar':
        this.routes.navigate(['/system/approbation-group/detail', event.data.idGrupo]);
        break;
      case 'eliminar':
        const deleteDialog = this.dialog.open(AlertComponent, {
          data: {
            icon: "exclamation-circle",
            iconColor: "failure",
            title: "Aviso",
            text: "¿Está seguro que desea eliminar el Grupo de Aprobación?",
            options: true,
          },
        });
        deleteDialog.afterClosed().subscribe(
          (result) => {
            if (result) {
              this.deleteGroup(event.data.idGrupo);
            }
          },
          (error) => {
            console.log("error", error);
          }
        );

        break;
    }
  }
  deleteGroup(id) {

    this.approbationService.deleteGroup(id).subscribe((result) => {
      this.approbationService.getAprobbations().subscribe((ApprobactionResult) => {
        this.getTableData(ApprobactionResult);
        this.notifierService.systemNotify({
          title: "Éxito",
          message: "Se ha eliminado el grupo de aprobación",
          type: "success",
        });
      }, (error) => {
        this.getTableData([]);
        this.notifierService.systemNotify({
          title: "Ha ocurrido un error",
          message:"Por favor póngase en contacto con el administrador",
          type: "error",
        });
      });
    }, (error) => {
      this.getTableData([]);
      this.notifierService.systemNotify({
        title: "Ha ocurrido un error",
        message: "Por favor póngase en contacto con el administrador",
        type: "error",
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/system/approbation-group/approbation-group.component.ts